export default function NotFound() {
  return (
    <div className="NotFound">
      <p>404 Page Not Found plate contact admin</p>
    </div>
  )
}
